import { useState } from "react";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { BusinessAreaSaveModel } from "../businessAreaDialog/BusinessAreaDialog.types";
import { BusinessAreaViewModel } from "./BusinessAreas.types";

import { useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";

export function useBusinessAreasDataMapping() {
    const queryClient = useDotLegalQueryClient();
    const [showAllBusinessAreas, setShowAllBusinessAreas] = useStateLocalStorage("onlyActivePurposes", false);
    const [showBusinessAreaDialog, setShowBusinessAreaDialog] = useState(false);
    const [showDeleteBusinessAreaDialog, setShowDeleteBusinessAreaDialog] = useState(false);
    const [selectedBusinessArea, setSelectedBusinessArea] = useState<BusinessAreaSaveModel | undefined>(undefined);
    const [showChangeStatusDialog, setShowChangeStausDialog] = useState(false);

    const queryPart = `?showAllPurposes=${showAllBusinessAreas}`;
    const url = `/businessareas${queryPart}`;
    let { isLoading, data } = useDotLegalQuery<Array<BusinessAreaViewModel>>(url);

    const OnSave = () => {
        queryClient.refetchQueries(url);
    };

    return {
        isLoading,
        data,
        showAllBusinessAreas,
        setShowAllBusinessAreas,
        showBusinessAreaDialog,
        setShowBusinessAreaDialog,
        showDeleteBusinessAreaDialog,
        setShowDeleteBusinessAreaDialog,
        OnSave,
        selectedBusinessArea,
        setSelectedBusinessArea,
        showChangeStatusDialog,
        setShowChangeStausDialog,
    };
}
